export class Position2D {
	x: number;
	y: number;
	constructor (x, y) {
		this.x = x;
		this.y = y;
	}
}
